import { ChoicesComponentFilter } from "@generated"
import { useRouter } from "next/router"
import { useState } from "react"

export function useConfiguratorTabs() {
  const [tab, setTab] = useState(ChoicesComponentFilter["Stone"])
  const router = useRouter()

  let allowedTabs = [
    ChoicesComponentFilter["Base"],
    ChoicesComponentFilter["Frame"],
    ChoicesComponentFilter["Stone"],
  ]
  // Only earrings & rings with style classic or oval have a seperate frame
  if (!["classic", "oval"].includes(router.query?.style as string)) {
    allowedTabs = [
      ChoicesComponentFilter["Base"],
      ChoicesComponentFilter["Stone"],
    ]
  }

  return {
    tab,
    setTab,
    allowedTabs,
  }
}
